import Accessibility from "./Accessibility";
import Alerts from "./Alerts";
import ColorLimits from "./ColorLimits";
import EmergencyReferences from "./EmergencyReferences";
import Instructions from "./Instructions";
import Paging from "./Paging";
import StandardReferences from "./StandardReferences";
import Verification from "./Verification";
import WhatsNew from "./WhatsNew";

export default {
  Instructions,
  ColorLimits,
  Alerts,
  Paging,
  StandardReferences,
  EmergencyReferences,
  Accessibility,
  WhatsNew,
  Verification
};
